import apiRequestType from "../../apiRequestType";
import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import { getAxiosCancelToken } from "../../../utils/getAxiosCancelToken";

let cancelToken;

const getMobileInstallationTrend = (classId, fromDate, toDate, userGroupId) => {
  cancelToken = getAxiosCancelToken(cancelToken);
  return apiRequestType(
    apiTypes.GET,
    apiConstants.REPORT.ADOPTION_REPORT.GET_MOBILE_INSTALLATION_TREND(
      classId,
      fromDate,
      toDate,
      userGroupId
    ),
    cancelToken
  );
};

export default getMobileInstallationTrend;
